/**
 * PLP shared constants for browse, search, recently-viewed, etc.
 */

export const PLP_PAGE_SIZE = 24;
export const PLP_DEFAULT_TAG = 'jewellery';
export const PLP_DEFAULT_SORT = 'mostpopular';

export const PLP_SORT_OPTIONS = [
  { label: 'Whats New', value: 'date_add' },
  { label: 'Popular', value: 'mostpopular' },
  { label: 'Price Low To High', value: 'pricelow' },
  { label: 'Price High To Low', value: 'pricehigh' },
  { label: 'Discount', value: 'discount' },
] as const;

export type PlpSortByValue = (typeof PLP_SORT_OPTIONS)[number]['value'];

/** Default product row height (used when not using dynamic measurement). */
export const PLP_ROW_HEIGHT_PRODUCT = 320;

/** Initial estimate for product rows when using measureElement. Kept large so no overlap before actual measurement. */
export const PLP_ROW_HEIGHT_PRODUCT_ESTIMATE = 420;

export const PLP_ROW_HEIGHT_BANNER = 100;
export const PLP_SENTINEL_HEIGHT = 80;

/** Shared max container width for all PLP layouts (px). */
export const PLP_MAX_WIDTH = 1520;

/** Browse PLP main column max width (design: 1520px). */
export const PLP_BROWSE_PAGE_MAX_CLASS = `mx-auto w-full max-w-[${PLP_MAX_WIDTH}px]`;

/** Desktop PLP header banner: 1510×110 (design). */
export const PLP_DESKTOP_BANNER_CLASS = 'mx-auto h-[110px] w-full max-w-[1510px]';

/** Page-service listing API path segments (base = getPageApiBaseUrl()). */
export const PLP_LISTING_API_PATH = '/listing';
export const PLP_LISTING_FILTERS_API_PATH = '/listing/filters';
export const PLP_SEO_DATA_API_PATH = '/seo-data';

/** page_type query param values for unified listing APIs. */
export const PLP_PAGE_TYPE = {
  BROWSE: 'browse',
  STORE: 'store',
  SEARCH: 'search',
  HOME: 'home',
  IMAGE_SEARCH: 'imageSearch',
} as const;

export type PlpPageType = (typeof PLP_PAGE_TYPE)[keyof typeof PLP_PAGE_TYPE];

